import React, { useState, useContext } from 'react';

/* import Bg from  '../../assets/slide4.jpg';*/
import Logo from '../assets/logo.png'; 
import '../styles/register.css';

import * as Constants from '../constants';
import { ShareContext } from '../context/ShareContext'
import { Link, useNavigate } from 'react-router-dom';
import BackLoader from '../components/backloader'
import DynamicIcon from '../components/dynamicicon';
import JisButton from '../components/controls/jisButton';
import JisDialog from '../components/dialog';

function ForgetPassword() {
    const [staySigned, setStaySigned] = useState(false)
    const navigate = useNavigate();
    const { profile , setProfile, setToken} = useContext(ShareContext);
    

    const [seePass, setSeePass] = useState(false);
    const [err, setErr] = useState('');
    const [loading, setLoading] =useState(false);
    
    const [login, setLogin]= useState({username:'',password:''});
  const [flowerror, setFlowError]=useState('');
  const [isPass, setIsPass]=useState(true);
  const [sucess_msg, setSucessMsg]= useState('');
const [isSucess, setIsSuccess] =useState(false);

     const onLoginChange = (e) => {
    setLogin({...login, [e.target.name]: e.target.value})
}
const onBack=()=>{
  navigate('/');
}
    const onLogin=async(e)=>{
        e.preventDefault(); 
  
          setLoading(true);
          
          try {
           
            const resp = await fetch(`${Constants.apiUrl}/profile/resetrequest`, {
              method: 'POST',
              body:JSON.stringify(login) ,
              headers: {
                'Content-Type': 'application/json, text/plain',
                'Authorization': '',
              },
            });
            
            const data = await resp.json();
            setLoading(false);
            console.log(data);
            if (data.code === 0) {
              
               setSucessMsg("The reset details sent to your email. Please follow the link");
               setIsSuccess(true);
            }else {   
              setFlowError('The Username not on our system');
            }
          } catch (error) {
            setLoading(false);
            console.error(error);
            setErr(Constants.serverErr);
           // onMove();
          }
  
         }
const GotoLogin=()=>{
        setIsSuccess(false);
        navigate('/login');
        
    }
  return (
    <div class="reg_container">
       {loading &&  <BackLoader />}
    <div class="homeside">
        <div style={{flex:1}}>
             <img src={Logo} alt="JIS Logo" className='logo' style={{width:100}}/> 
        </div>
      
       
                <div className="boxx">
                    
                    <p className="text"><div>1. </div> <div> You can register as a Legal Counsel, Non-legal Counsel and also do E-Affidavit.</div></p>
                    <p className="text"> <div>2.</div><div className='dtext'>For Individual and Organisation registration you need a Payer ID.</div> </p>
                    <p className="text"><div>3. </div><div className='dtext'>If you have a Payer ID select the option "I have a Payer ID</div> </p>
                    <p className="text"><div>4. </div><div className='dtext'>If you do not have a Payer ID select the option "I do not have a Payer ID</div> </p>
                    <p className="text"><div>5. </div><div className='dtext'>If you do not have a Payer ID you can generate the Payer ID during the registration process.
                     It is mandatory  to enter the NIN when the fields are displayed.</div> </p>
                    <p className="text"> <div>6.</div><div className='dtext'> Once you are done with the last step, click the "Submit" button
                     to complete the registration process.</div></p>
                </div>
</div>

    <main  class="contentside">
      <div  className='success-final'>
        <div className='form-box'>

 <div>
                <div className="boo" onClick={onBack}>
                        <DynamicIcon size={16} iname="chevron-left" />
                        <a className="back">Back</a>
                    </div>
      <div  className='content-title'>Forget Password</div>
               </div>
      <p class="subtitle">Provide your username and reset details will be sent to you</p>
<div className='success_msg'>{sucess_msg}</div>
      <form onSubmit={onLogin}>
        <div  className="input-group">
            <label> Username</label>
            <div className='input-wrapper'>
                <DynamicIcon iname="person_3" />
                <input  placeholder='Username' required={true} name="username" value={login.username} onChange={onLoginChange}   />
            </div>
        </div>
        

       
 {flowerror!='' && <div className='error'>{flowerror}</div>}
        <div style={{display:'flex', flexDirection:'column'}}>
             <JisButton type='submit'>Reset Password</JisButton>
             <div style={{textAlign:'center',margin:20}}>
                <Link to="/login">Login</Link>
             </div>   
        </div>
           

      </form>
        </div>


      </div>
     
      
    </main>
  {isSucess && <JisDialog title="Password Reset Request">
      <div>{sucess_msg}</div>
      <JisButton onClick={GotoLogin}>Goto Login</JisButton>
    </JisDialog>} 
      
  </div>
  )
}

export default ForgetPassword